import { forwardRef } from "react";
import { node } from "prop-types";
import { SESSION_PLAYER_PADDING } from "../utils";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const PlayerFrame = forwardRef(({
  children,
}, ref) => {
  const classes = useStyle();
  
  return (
    <Grid
      item container
      xs={9}
      className="h-full"
    >
      <Paper
        className={classes.root}
        ref={ref}
      >
        { children }
      </Paper>
    </Grid>
  )
});

PlayerFrame.propTypes = {
  children: node.isRequired,
}

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    borderRadius: 5,
    boxShadow: "none",
    border: "1px solid " + theme.props.border,
    padding: SESSION_PLAYER_PADDING,
    position: "relative",
  },
}));